<template>
	<div class="scrollable only-y">
        <div class="page-header card-base card-shadow--medium" element-loading-background="rgba(0, 0, 0, 0.8)">
            <h2 class="no-m white-text"><i class="mdi mdi-bank widget-icon accent-text fs-30"></i> Finance Tax Invoice</h2>
        </div>
        <el-card>
            <el-tabs type="border-card" v-model="activeTab" v-loading="loadingPage">
                <el-tab-pane label="Collection" name="collection">
                    <el-row>
                        <el-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24" justify="end">
                            <template>
                                <el-date-picker
                                    style="width:280px;"
                                    v-model="selectedStartDate"
                                    range-separator="-"
                                    size="mini"
                                    type="daterange"
                                    placeholder="Period"
                                    class="mr-5"
                                >
                                </el-date-picker>
            
                                <el-select @change="companySelected" v-model="selectedCompanyName" placeholder="Company Name" style="width:130px;" size="mini" :default-first-option="true" class="mb-10 mr-5">
                                    <el-option
                                        v-for="(item, idx) in consumenData"
                                        :label="item.customer_name"
                                        :value="item.customer_id"
                                        :key="idx"
                                    />
                                </el-select>
            
                                <el-select v-model="selectedPhoneNumber" placeholder="Phone Number" style="width:140px;" size="mini" :default-first-option="true" class="mb-10 mr-5">
                                    <el-option
                                        v-for="(item, idx) in listPhoneNumber"
                                        :label="item"
                                        :value="item"
                                        :key="idx"
                                    />
                                </el-select>
                                
                                <el-select v-model="selectedPaidType" placeholder="Paid Type" style="width:140px;" size="mini" :default-first-option="true" class="mb-10 mr-5">
                                    <el-option
                                        v-for="itm in paidType"
                                        :key="itm.value"
                                        :label="itm.name"
                                        :value="itm.value"
                                    >
                                    </el-option>
                                </el-select>
        
                                <el-input
                                    placeholder="Invoice Number"
                                    size="mini"
                                    style="width:200px;"
                                    v-model="invoiceNumber"
                                />
        
                                <el-button-group class="mr-10 ml-10">
                                    <el-button
                                        type="primary"
                                        round
                                        size="mini"
                                        class="animated fadeInRight"
                                        style="background-color: #0047FF;"
                                        :loading="btnSearchTaxInvoice"
                                        @click="searchTaxInvoice()"
                                    >
                                        <i class="el-icon-search"/>
                                    </el-button>
                                </el-button-group>
        
                                <!-- <el-select v-model="selectedSummary" placeholder="Summary" style="width:140px;" size="mini" :default-first-option="true" class="mb-10 mr-5">
                                    <el-option
                                        v-for="itm in summary"
                                        :key="itm.value"
                                        :label="itm.name"
                                        :value="itm.value"
                                    >
                                    </el-option>
                                </el-select> -->
                                
                                <!-- <el-button
                                    type="primary"
                                    size="mini"
                                    :loading="loadingDownload"
                                    class="animated fadeInRight"
                                >
                                    <i class="mdi mdi-download"/>
                                </el-button> -->
                            </template>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-table
                            style="width: 100%"
                            element-loading-text="Loading..."
                            element-loading-spinner="el-icon-loading"
                            :data="listData"
                            :loading="loadingTable"
                            height="500"
                        >
                            <el-table-column prop="client_name" label="Client Name" width="200">
                                <template slot-scope="scope">
                                    <p>{{ scope.row.client_name ? scope.row.client_name : '-' }}</p>
                                </template>
                            </el-table-column>
                            <!-- <el-table-column prop="tax_invoice" label="Tax Invoice" width="200">
                                <template slot-scope="scope">
                                    <div>
                                        <p v-if="scope.row.tax_invoices">{{scope.row.tax_invoices}}</p>
                                        <div v-if="scope.row.tax_invoices">
                                            <el-button @click="editInvoice()" type="success" size="mini" class="animated fadeInRight">
                                                Edit
                                            </el-button>
                                            <el-button type="primary" size="mini" class="animated fadeInRight">
                                                Download
                                            </el-button>
                                        </div>
                                        <div v-else-if="!scope.row.tax_invoices">
                                            <el-button
                                                type="primary"
                                                size="mini"
                                                class="animated fadeInRight"
                                                @click="insertInvoiceNumber(scope.row.id)"
                                            >
                                                Insert
                                            </el-button>
                                        </div>
                                    </div>
                                </template>
                            </el-table-column> -->
                            <el-table-column prop="tax_date" label="Tax Date" width="200">
                                <template slot-scope="scope">
                                    <p>{{ formatedDate(scope.row.tax_date) }}</p>
                                </template>
                            </el-table-column>
                            <el-table-column prop="invoice_number" label="Invoice Number" width="200">
                                <template slot-scope="scope">
                                    <p>{{ scope.row.invoice_number }}</p>
                                </template>
                            </el-table-column>
                            <el-table-column prop="paid_type" label="Paid Type" width="100">
                                <template slot-scope="scope">
                                    <p style="text-transform: capitalize;">{{ scope.row.paid_type }}</p>
                                </template>
                            </el-table-column>
                            <el-table-column prop="phone_number" label="Phone Number" width="150">
                                <template slot-scope="scope">
                                    <p>{{ scope.row.customer_phone }}</p>
                                </template>
                            </el-table-column>
                            <el-table-column prop="phone_owner" label="Phone Owner" width="200">
                                <template slot-scope="scope">
                                    <p>{{ scope.row.customer_name }}</p>
                                </template>
                            </el-table-column>
                            <el-table-column prop="item_name" label="Item Name" width="200">
                                <template slot-scope="scope">
                                    <p>-</p>
                                </template>
                            </el-table-column>
                            <el-table-column prop="unit_price" label="Unit Price" width="150">
                                <template slot-scope="scope">
                                    <div
                                        v-for="item in scope.row.collection_detail"
                                        style="height:2em;"
                                    >
                                        <p>{{ formatPrice(item.unit_price) }}</p>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="discount" label="Discount" width="100">
                                <template slot-scope="scope">
                                    <div
                                        v-for="item in scope.row.collection_detail"
                                        style="height:2em;"
                                    >
                                        <p>{{ formatPrice(item.discount) }}</p>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="quantity" label="Quantity" width="100">
                                <template slot-scope="scope">
                                    <div
                                        v-for="item in scope.row.collection_detail"
                                        style="height:2em;"
                                    >
                                        <p>{{ item.qty }}</p>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="dpp" label="DPP" width="100">
                                <template slot-scope="scope">
                                    <div
                                        v-for="item in scope.row.collection_detail"
                                        style="height:2em;"
                                    >
                                        <p>{{ formatPrice(item.dpp) }}</p>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="ppn" label="PPN" width="100">
                                <template slot-scope="scope">
                                    <div
                                        v-for="item in scope.row.collection_detail"
                                        style="height:2em;"
                                    >
                                        <p>{{ formatPrice(item.ppn) }}</p>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="pph" label="PPH 23" width="100">
                                <template slot-scope="scope">
                                    <div
                                        v-for="item in scope.row.collection_detail"
                                        style="height:2em;"
                                    >
                                        <p>{{ item.pph ? formatPrice(item.pph) : '-' }}</p>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="pp" label="PP 23" width="100">
                                <template slot-scope="scope">
                                    <div
                                        v-for="item in scope.row.collection_detail"
                                        style="height:2em;"
                                    >
                                        <p>{{ item.pp ? formatPrice(item.pp) : '-' }}</p>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="total" label="Total" width="100">
                                <template slot-scope="scope">
                                    <div
                                        v-for="item in scope.row.collection_detail"
                                        style="height:2em;"
                                    >
                                        <p>{{ `Rp ${item.dpp + item.ppn}` }}</p>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="period" label="Period" width="150">
                                <template slot-scope="scope">
                                    <p>{{ formatedDateMonth(scope.row.tax_date) }}</p>
                                </template>
                            </el-table-column>
                            <el-table-column prop="description" label="Description" width="200">
                                <template slot-scope="scope">
                                    <div
                                        v-for="item in scope.row.collection_detail"
                                        style="height:2em;"
                                    >
                                        <p>-</p>
                                    </div>
                                </template>
                            </el-table-column>
                            <!-- <el-table-column prop="action" label="Action" width="100">
                                <template slot-scope="scope">
                                    <div
                                        v-for="item in scope.row.collection_detail"
                                        style="height:3em !important;display: flex;align-items: center;"
                                    >
                                        <el-button @click="editData(item)" type="success" size="mini" class="animated fadeInRight">
                                            <i class="mdi mdi-pencil"></i>
                                        </el-button>
                                    </div>
                                </template>
                            </el-table-column> -->
                        </el-table>
                    </el-row>
                </el-tab-pane>
            </el-tabs>
        </el-card>
        <el-card class="mt-20 mb-20 card-base" style="border:none; color:white;">
            DAM Corp.
        </el-card>
        <!-- insert invoice number -->
        <el-dialog title="Insert Invoice" :visible.sync="dialogInsertInvoice" id="html-2-pdfwrapper">
            <el-row class="mt-5">
                <el-col :span="24" :md="24" :sm="24" :xs="24">
                    <el-form label-position="top">
                        <el-form-item label="Date">
                            <el-input type="text" disabled />
                        </el-form-item>
                        <el-form-item label="Invoice Number">
                            <el-input type="text" disabled />
                        </el-form-item>
                        <el-form-item label="Tax Invoice Number">
                            <el-input type="text"/>
                        </el-form-item>
                    </el-form>
                </el-col>
            </el-row>
            <el-row class="mt-40">
                <el-button :loading="btnLoadingInvoiceNumber" size="medium" type="primary">Save</el-button>
                <el-button size="medium" type="danger" @click="dialogInsertInvoice=false">Cancel</el-button>
            </el-row>
		</el-dialog>
        <!-- edit invoice number -->
        <el-dialog title="Edit Invoice" :visible.sync="dialogEditInvoice" id="html-2-pdfwrapper">
            <el-row class="mt-5">
                <el-col :span="24" :md="24" :sm="24" :xs="24">
                    <el-form label-position="top">
                        <el-form-item label="Date">
                            <el-input type="text" disabled />
                        </el-form-item>
                        <el-form-item label="Invoice Number">
                            <el-input type="text" disabled />
                        </el-form-item>
                        <el-form-item label="Tax Invoice Number">
                            <el-input type="text"/>
                        </el-form-item>
                    </el-form>
                </el-col>
            </el-row>
            <el-row class="mt-40">
                <el-button :loading="btnLoadingInvoiceNumber" size="medium" type="primary">Save</el-button>
                <el-button size="medium" type="danger" @click="dialogEditInvoice=false">Cancel</el-button>
            </el-row>
		</el-dialog>
        <!-- edit invoice number -->
        <el-dialog title="Edit Data" :visible.sync="dialogEditDataNumber" id="html-2-pdfwrapper">
            <el-row class="mt-5">
                <el-col :span="24" :md="24" :sm="24" :xs="24">
                    <el-form label-position="top">
                        <el-form-item label="Unit Price">
                            <el-input :value="selectedEditData.unit_price" type="text" disabled />
                        </el-form-item>
                        <el-form-item label="Discount">
                            <el-input v-model="selectedEditData.discount" type="text" />
                        </el-form-item>
                        <el-form-item label="Quantity">
                            <el-input v-model="selectedEditData.qty" type="text"/>
                        </el-form-item>
                        <el-form-item label="DPP">
                            <el-input :value="selectedEditData.dpp" type="text" disabled />
                        </el-form-item>
                        <el-form-item label="PPN">
                            <el-input :value="selectedEditData.ppn" type="text" disabled />
                        </el-form-item>
                        <el-form-item label="Total">
                            <el-input :value="selectedEditData.dpp + selectedEditData.ppn" type="text" disabled/>
                        </el-form-item>
                        <el-form-item label="Description">
                            <el-input v-model="selectedEditData.description" type="textarea"/>
                        </el-form-item>
                    </el-form>
                </el-col>
            </el-row>
            <el-row class="mt-40">
                <el-button :loading="btnLoadingEditInvoiceNumber" size="medium" type="primary">Save</el-button>
                <el-button size="medium" type="danger" @click="dialogEditDataNumber=false">Cancel</el-button>
            </el-row>
		</el-dialog>
	</div>
</template>

<script>
import api from '@/networkClient'
import config from '@/config'
const moment = require('moment')
import Template from './consumen/Template.vue'

export default {
  components: { Template },
	name: 'tax-invoice',
    data() {
        return {
			activeTab: "collection",
            paidType: [
                {
                    name: 'Topup',
                    value: 'topup'
                },
                {
                    name: 'Invoice',
                    value: 'invoice'
                }
            ],
            summary: [
                {
                    name: 'Summary',
                    value: 'summary'
                },
                {
                    name: 'Inovice',
                    value: 'invoice'
                },
                {
                    name: 'Bill Detail',
                    value: 'billDetail'
                }
            ],
            listData: [],
            selectedStartDate: [
                moment().subtract(1,"day").format("YYYY-MM-DD"),
                moment().subtract(1,"day").format("YYYY-MM-DD")
            ],
            selectedCompanyName: '',
            selectedPhoneNumber: '',
            selectedPaidType: '',
            invoiceNumber: '',
            selectedSummary: '',
            loadingDownload: false,
            loadingTable: false,
            dialogInsertInvoice: false,
            btnLoadingInvoiceNumber: false,
            dialogEditDataNumber: false,
            btnLoadingEditInvoiceNumber: false,
            selectedEditData: {},
            dialogEditInvoice: false,
            reqInvoiceData: {},
            loadingPage: false,
            consumenData: [],
            listPhoneNumber: [],
            btnSearchTaxInvoice: false
        }
    },
    methods: {
        log(data) {
            console.log(data, " <<Data");
        },
        async searchTaxInvoice() {
            this.btnSearchTaxInvoice = true;
            await this.getListTaxInvoice();
            this.btnSearchTaxInvoice = false;
        },
        formatPrice(val){
			return new Intl.NumberFormat("id-ID", { style: "currency", currency: "IDR", minimumFractionDigits: 0 }).format(val);
		},
        formatedDate(date) {
            return moment(date).format('DD/MM/YYYY');
        },
        formatedDateMonth(date) {
            return moment(date).format('MMMM');
        },
        editData(data) {
            this.selectedEditData=data;
            this.dialogEditDataNumber=true;
        },
        editInvoice(){
            this.dialogEditInvoice=true;
        },
        async insertInvoiceNumber(id){
            this.dialogInsertInvoice=true;
            await api({
                method: 'get',
                url: config.baseApi + `master-collection/request-invoice/${id}`
            })
            .then(res => {
				var status =
					res &&
					res.data &&
					res.data.ec
						? res.data.ec
						: null;
				var data =
					res &&
					res.data &&
					res.data.data
						? res.data.data
						: {};
				if (status === 200) {
					this.reqInvoiceData = data;
				}
            })
            .catch(err => {
                this.$swal(this.$t('error'), this.$t('error_text'), "error").then(this.clear())
                return err
            })
        },
        async getListTaxInvoice() {
            this.loadingTable=true;
            this.loadingPage=true;

            let param = {
                customer_id: this.selectedCompanyName,
                phone_number: this.selectedPhoneNumber,
                paid_type: this.selectedPaidType,
                invoice_number: this.invoiceNumber
            };

            await api({
				method: 'get',
				url: 'master-collection',
                params: param
			}).then(result => {
                var data =
                    result &&
                    result.data &&
                    !result.data.data
                        ? result.data.data
                        : [];

                var status =
                    result &&
                    result.data &&
                    result.data.ec
                        ? result.data.ec
                        : null;
                if (status === 200) {
                    this.listData = data;
                }
			}).catch(error => {
				return error
			})
            this.loadingPage=false;
            this.loadingTable=false;
        },
        async getConsumen(){
			await api({
				method: "get",
				url: config.baseApi + "consumen",
				params: {
                    customer_type: 2,
					query_by: 'waba_number',
                    dropdown: true
				}
			}).then(resp => {
                const status =
                    resp &&
                    resp.data &&
                    resp.data.ec
                        ? resp.data.ec
                        : null;
                const data =
                    resp &&
                    resp.data &&
                    resp.data.data &&
                    resp.data.data.consumen
                        ? resp.data.data.consumen
                        : [];
				if(status == 200){
                    this.consumenData = data;
				}
			}).catch(err => {
				console.log("failed", err)
			})
		},
        companySelected() {
            this.selectedPhoneNumber = ''
            var id = this.selectedCompanyName ? this.selectedCompanyName : '';
            this.loadWA(id);
        },
        async loadWA(id) {
			await api({
				method: 'post',
				url: config.baseApi +'user/'+id+'/detail_number'
			}).then(result => {
                const status =
                    result &&
                    result.data &&
                    result.data.ec
                        ? result.data.ec
                        : null;
                const data =
                    result &&
                    result.data &&
                    result.data.data
                        ? result.data.data
                        : [];
				if(status == 200){
                    this.listPhoneNumber = data;
				} else {
                    this.listPhoneNumber = [];
                }
			}).catch(error => {
                console.log('Error:', error)
			})
		}
    },
   	async mounted(){
		await this.getListTaxInvoice();
        await this.getConsumen();
    },
    computed: {
        
    }
}
</script>
<style scoped>
.swal2-container {
	z-index: 10000 !important;
}

.img-center {
    display: block;
    margin-bottom: 0px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 30px;
    width: 50%;
}

table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

td, th {
  border: 1px solid #ffffff;
  text-align: left;
  padding: 8px;
}

tr:nth-child(even) {
  background-color: #dddddd;
}
table th {
  background: #79DFFF;
  color: black;
  font-weight: bold;
  /* font-size: 18px; */
}
/* .css-serial { */
  /* counter-reset: serial-number;  Atur penomoran ke 0 */
/* } */
/* .css-serial td:first-child:before { */
  /* counter-increment: serial-number;  Kenaikan penomoran */
  /* content: counter(serial-number);  Tampilan counter */
/* } */
</style>
<style lang="scss">
@import '../assets/scss/_variables';

.gradient-api {
	background:#249393;
	background: linear-gradient(260deg, #4ac5c5, #249393);
}
.white-text {
	color: white;
}
.page-header {
	margin-bottom: 30px;
}

.row {
	margin-top: 30px;
}

.page-invoice {
	.toolbar {
		max-width: 794px;
		margin: 0 auto;
		text-align: right;
		margin-bottom: 20px;
	}

	.invoice {
		background: white;
		width: 100%;
		max-width: 794px;
		min-height: 1123px;
		margin: 0 auto;
		padding: 2em;
		box-sizing: border-box;
		box-shadow: 0px 8px 8px -8px rgba(0, 0, 0, 0.3);

		hr {
			border: 1px solid rgba(0, 0, 0, 0.05);
		}

		.invoice-top {
			overflow: hidden;
			float: right;
			margin-bottom: 30px;

			.logo {
				float: right;
				height: 60px;
				width: 60px;
				box-sizing: border-box;
				border-radius: 50%;
				overflow: hidden;
				background: rgba(0, 0, 0, 0.07);
				text-align: center;

				img {
					height: 80%;
					margin-top: 10%;
				}
			}
			.info {
				display: block;
				float:left;
				margin-left: 20px;
				margin-top: 5px;

				& > * {
					margin: 0;
				}
			}
			.title {
				float: right;

				& > * {
					margin: 0;
				}

				p {
					text-align: right;
				}
			}
		}

		.invoice-middle {
			overflow: hidden;
			margin-top: 30px;
			margin-bottom: 30px;

			.clientlogo {
				float: left;
				height: 60px;
				width: 60px;
				box-sizing: border-box;
				border-radius: 50%;
				overflow: hidden;
				background: grey;

				img {
					width: 100%;
				}
			}

			.info {
				display: block;
				float:left;
				margin-left: 20px;
				margin-top: 5px;

				& > * {
					margin: 0;
				}
			}

			.project {
				margin-left: 52%;

				& > * {
					margin: 0;
				}
			}
		}

		.invoice-bottom {
			table {
				width: 100%;
				border-collapse: collapse;

				th {
					text-align: right;
					padding: 20px;
					padding-bottom: 5px;
					opacity: .7;

					&:first-child {
						text-align: left;
						padding-left: 0px;
						// width: 100%
					}
					&:last-child {
						padding-right: 0px;
					}
				}

				td {
					text-align: right;
					padding: 20px;
					padding-bottom: 5px;
					border-bottom: 1px solid #EEE;

					&:first-child {
						text-align: left;
						padding-left: 0px;
						// width: 100%;
					}
					&:last-child {
						padding-right: 0px;
					}
				}

				tfoot td {
					border: none;
					padding-top: 5px;
				}
			}
		}

		h1 { font-size: 1.5em; color: #222; }
		h2 { font-size: .9em; }
		h3 { font-size: 1.2em; font-weight: 300; line-height: 2em; }
		p  { font-size: .7em; color: #666; line-height: 1.2em; }
	}

}


@media print{
	.layout-container .container .footer ,
	.layout-container .container .header ,
	.layout-container .container .horizontal-nav ,
	.layout-container .footer ,
	.layout-container .layout-picker ,
	.layout-container .vertical-nav ,
	.layout-container .header {
		display:none;
	}
}
</style>
